export default __webpack_public_path__ + "static/media/classic04.bfbd88f0.png";